import { axiosInstance } from "../config/axios";

export interface TokenResponse {
    balance: number,
    totalPurchased: number,
    totalUsed: number,
    totalRefunded: number,
    isActive: boolean,
}

export interface TokenPackage {
    _id: string;
    name: string;
    tokens: number;
    price: number;
    currency: string;
    isActive: boolean;
    createdAt: Date;  
    updatedAt: Date;
}

export interface PurchaseTokenResponse {
    purchaseId: string;
    paymentUrl?: string;
    message: string;
}

export interface PaymentVerificationResponse {
    status: 'success' | 'failed' | 'pending' | 'completed';
    message: string;
    purchaseId?: string;
    tokens?: number;
    tokensAdded?: number;
    errorReason?: string;
}

class TokenService {
    getTokenBalance = async () => {
        const response = await axiosInstance.get<TokenResponse>('/tokens/balance');
        return response.data;
    }

    getTokenPackages = async () => {
        const response = await axiosInstance.get<TokenPackage[]>('/tokens/packages');
        return response.data;
    }

    purchaseTokens = async (packageId: string) => {
        const response = await axiosInstance.post<PurchaseTokenResponse>('/tokens/purchase', { packageId });
        return response.data;
    }

    verifyPayment = async (purchaseId: string) => {
        const response = await axiosInstance.get<PaymentVerificationResponse>(`/tokens/verify-payment/${purchaseId}`);
        return response.data;
    }
}

export default new TokenService();